var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.06 428.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.87,321.05A17.84,17.84,0,1,1,214,303.21,17.83,17.83,0,0,1,231.87,321.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214,428.06c-118,0-214-96-214-214S96,0,214,0s214,96,214,214S332.05,428.06,214,428.06Zm0-401.31c-103.27,0-187.28,84-187.28,187.28s84,187.28,187.28,187.28S401.31,317.3,401.31,214,317.3,26.75,214,26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214,263.08a13.39,13.39,0,0,1-13.38-13.38v-18a40.23,40.23,0,0,1,26.79-37.85c21.32-7.51,35.64-30.21,35.64-46.69a49.05,49.05,0,1,0-98.1,0,13.38,13.38,0,0,1-26.75,0,75.81,75.81,0,1,1,151.61,0c0,29.75-23.5,61.34-53.5,71.93a13.37,13.37,0,0,0-8.93,12.63v18A13.38,13.38,0,0,1,214,263.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.fe1d70551e95ab77d08d98bfa5b5eaf8.svg";
export { ForwardRef as ReactComponent };